export default {
  minLen: 3,
  wait: 0,
  timeout: null,

  isUpdateItems (text) {
    return text.length >= this.minLen
  },

  callUpdateItems (text, cb) {
    clearTimeout(this.timeout)
    if (this.isUpdateItems(text)) this.timeout = setTimeout(cb, this.wait)
  },

  findItem (items, text, autoSelectOneResult) {
    if (!text) return
    if (autoSelectOneResult && items.length === 1) return items[0]
  }

}



//////////////////
// WEBPACK FOOTER
// ./node_modules/lei-shared/autocomplete/utils.js
// module id = IbZ+
// module chunks = 0